<template>
  <b-modal :id="modalId" class="modal-exit" ref="modal" hide-header>
    {{ $t('modals.exit.title') }}
    <div slot="modal-footer">
      <b-button variant="link"
        @click="close('no')">
        {{ $t('modals.exit.no') }}
      </b-button>
      <b-button variant="primary"
        @click="close('yes')">
        {{ $t('modals.exit.yes') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
const ModalExit = {
  name: 'ModalExit',

  props: ['modalId'],

  methods: {
    show() {
      this.$refs.modal.show();
    },

    close(event) {
      this.$refs.modal.hide();

      if (event === 'yes' && this.$store.state.g2wSession) {
        this.$store.dispatch('g2wSession/leave', {userInitiated: true});
      }

      if (event) {
        this.$emit(event);
      }
    }
  }
};

export default ModalExit;
</script>
